<template>
    <div class="resumeOther projectExp">
        <el-row>
            <el-col :span="4" class="resumeItem">
                <h1>项目经历</h1>
                <p>{{projectExperienceSize}}/10</p>
            </el-col>
            <el-col :span="20">
                <div v-for="(item,index) in resumeInfo.projectExperienceList" class="workExpList">

                    <div v-if="!resumeEditStatus" class="editBtn">
                        <!--编辑按钮-->
                        <el-button slot="reference" type="text" icon="el-icon-edit-outline"
                                   @click="edit(item)" v-has-permi="['resume:projectExperience:edit']"></el-button>

                        <!--删除按钮-->
                        <el-popconfirm title="确认删除项目经历？"
                                       placement="top-start"
                                       @confirm="deleteProjectExperience(item.id)"
                                       icon="el-icon-info"
                                       icon-color="red"
                                       v-has-permi="['resume:projectExperience:delete']">
                            <el-button slot="reference" type="text" icon="el-icon-delete"></el-button>
                        </el-popconfirm>
                    </div>

                    <!--编辑状态-->
                    <div v-if="editStatus.id==item.id && editStatus.status==true">
                        <div v-if="resumeEditStatus==true && projectExperienceEditStatus==true">
                            <project-experience-form :form="form" :resumeId="resumeInfo.id" :editStatus="editStatus" ></project-experience-form>
                        </div>
                    </div>

                    <!--非编辑状态-->
                    <div v-else class="resumeContent">

                        <el-row>
                            <el-col :span="12">
                                <p><b>
                                    {{item.startTime}} ~
                                    <span v-if="item.endTime">{{item.endTime}}</span>
                                    <span v-else>至今</span>
                                </b></p>
                            </el-col>
                            <el-col :span="12">
                                <p><b>{{item.projectName}}</b></p>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <p>所属单位：{{item.company}}</p>
                            </el-col>
                            <el-col :span="12">
                                <p>项目角色：{{item.roleName}}</p>
                            </el-col>
                        </el-row>
                        <p>项目描述：{{item.description}}</p>
                        <p>项目成果：{{item.achievement}}</p>
                    </div>

        </div>

        <div v-if="projectExperienceSize<10 && editStatus.status==false && resumeEditStatus==false && projectExperienceEditStatus==false"
             v-has-permi="['resume:projectExperience:add']" class="addExp">
            <el-button @click="add()" icon="el-icon-plus">添加项目经历</el-button>
        </div>

        <!--新增简历项目经历表单-->
        <div v-if="editStatus.status==false && resumeEditStatus==true && projectExperienceEditStatus==true">
            <project-experience-form :form="form" :resumeId="resumeInfo.id" :editStatus="editStatus" @editStatus="getEditStatus"></project-experience-form>
        </div>
            </el-col>
        </el-row>



    </div>
</template>
<script>
    import {saveProjectExperience,deleteProjectExperience} from '@/api/resume';
    import ProjectExperienceForm from './Form/ProjectExperienceForm.vue';

    export default {
        name: 'projectExperience',
        props: ['resumeInfo'],
        data () {
            return {
                // 表单编辑状态
                editStatus: {
                    id: 0,
                    status: false,
                },
                form: {},
                rules: {
                    projectName: [
                        {required: true, message: '请输入项目名称'},
                        {pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]{0,30}$/, message: '支持输入中英文和数字'}
                    ],
                    startTime: [
                        {required: true, message: '请选择项目时间'},
                    ],
                    endTime: [
                        {required: true, message: '请选择项目时间'},
                    ],
                    company: [
                        {pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]{0,30}$/, message: '支持输入中英文和数字'}
                    ],
                    roleName: [
                        {required: true, message: '请输入项目角色'},
                        {pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]{0,30}$/, message: '支持输入中英文和数字'}
                    ],
                    description: [
                        {max: 800},
                    ],
                    achievement: [
                        {max: 800},
                    ],
                },
            }
        },
        computed: {
            // 简历编辑状态
            resumeEditStatus(){
                return this.$store.state.index.resumeEditStatus;
            },
            // 简历项目经历编辑状态
            projectExperienceEditStatus(){
                return this.$store.state.index.projectExperienceEditStatus;
            },
            // 简历项目经历列表数量
            projectExperienceSize(){
                return this.size();
            }
        },
        methods: {
            // 计算简历项目经历数量
            size(){
                var projectExperienceSize = 0;
                for(var i in this.resumeInfo.projectExperienceList) {
                    projectExperienceSize++;
                }
                return projectExperienceSize;
            },
            // 表单进入编辑状态
            edit(item){
                this.add();
                this.form = Object.assign({}, item);
                this.editStatus.id = item.id;
                this.editStatus.status = true;
            },
            // 简历项目经历表单切换至编辑状态
            add() {
                this.form = {};
                this.$store.commit('changeResumeEditStatus', true);
                this.$store.commit('changeProjectExperienceEditStatus', true);
            },
            // 根据id删除项目经历
            deleteProjectExperience(id) {
                deleteProjectExperience(id).then(res => {
                    this.$store.commit('changeResumeRefreshFlag', true);
                })
            },
            getEditStatus(data) {
                this.editStatus = data;
            }
        },
        components: {
            ProjectExperienceForm,
        }
    }
</script>
